module.exports = __webpack_public_path__ + "static/media/moto_sha.b9a2effd.ogg";